export default function FacebookIcon({ className = "" }) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M21.8702 0.505371H2.62442C1.92838 0.505371 1.26085 0.781872 0.768676 1.27405C0.276501 1.76622 0 2.43376 0 3.1298L0 22.3756C0 23.0716 0.276501 23.7392 0.768676 24.2313C1.26085 24.7235 1.92838 25 2.62442 25H10.1286V16.6724H6.68408V12.7527H10.1286V9.76522C10.1286 6.36713 12.1516 4.49012 15.2501 4.49012C16.734 4.49012 18.2857 4.75475 18.2857 4.75475V8.08996H16.576C14.8914 8.08996 14.366 9.13535 14.366 10.2075V12.7527H18.1266L17.5251 16.6724H14.366V25H21.8702C22.5662 25 23.2338 24.7235 23.726 24.2313C24.2181 23.7392 24.4946 23.0716 24.4946 22.3756V3.1298C24.4946 2.43376 24.2181 1.76622 23.726 1.27405C23.2338 0.781872 22.5662 0.505371 21.8702 0.505371V0.505371Z" />
    </svg>
  );
}
